// TODO: stub — real implementation missing (not committed), remove when available
export function log() {}
export function error() {}
export function dump() { return [] }
export function count() { return 0 }
